export const games = {
  titleBreakingLeague: "BREAK DIE LIGA",
  titleBreakingLeagueMobile: "💥 BREAK DIE LIGA",
  gamesSubTitle: "Hulle wil niks vir enigiemand oorlaat nie.",
  recentTitle: "DIE MEES ONLANGSE",
  recentTitleMobile: "📢 DIE MEES ONLANGSE",
  recentSubTitle: "Probeer jou geluk met ons nuwe speletjies",
  newLabel: "NUUT",
  top10GamesTitle: "TOP",
  top10GamesTitle2: "SPELETJIES",
  top10GamesSubTitleDesktop: "Hierdie week se gunstelinge",
  top10GamesSubTitleMobile: "Die <highlight>10</highlight> mees gespeel in die hele Suid-Afrika",
  randomTitle: "Kan jy nie besluit nie?",
  randomTitleMobile: "🍀 Laat die geluk besluit!",
  randomDescription: "Druk speel en laat die geluk besluit.",
  randomDescriptionMobile: "Druk speel en laat die geluk besluit.",
  selectCategory: "Kies 'n kategorie",
  randomPlayButton: "Kom ons speel!",
  randomQuestion: "Watter sal die volgende speletjie wees om jou geluk te bring? 🍀",
  randomButton: "Gaan na speletjie 🚀",
  randomChipAll: "Almal",
  randomTryAnother: "Probeer 'n ander een",
  randomNoGames: "Geen speletjies in hierdie kategorie nie",
  randomPromoTitle: "Ontdek jou volgende gunsteling speletjie",
  randomPromoText: "Duisende speletjies wag op jou. Laat die geluk vir jou kies en ontdek nuwe ervarings.",
  randomPromoHint: "Probeer die ewekansige kieser →",
  topPayingGamesTitle: "TOP BETALENDE SPELETJIES",
  topPayingGamesSubTitle: "Geld val onophoudelik",
  recentlyPlayedTitle: "GAAN AAN WAAR JY OPGEFIOU HET",
  recentlyPlayedSubTitle: "Neem die aksie weer op met jou laaste speletjies",
  favoritesPageTitle: "❤️ {{alias}}, hierdie is jou gunstelinge",
  favoritesPageTitleGeneric: "❤️ Jou gunsteling speletjies",
  favoritesPageSubtitle: "Die speletjies waarvan jy die meeste hou, alles op een plek",
  favoritesGridTitle: "{{alias}} SE GUNSTELINGE",
  favoritesGridTitleGeneric: "JOU GUNSTELINGE",
  favoritesEmptyMessage:
    "Jy het nog geen gunsteling speletjies nie. Merk jou gunsteling speletjies deur die hartikoon te tik en kom terug hierheen wanneer jy jou topkeuses wil speel.",
  favoritesAdd: "Voeg by gunstelinge",
  favoritesRemove: "Verwyder uit gunstelinge",
  favoritesContinueTitle: "{{alias}}, gaan aan waar jy opgehou het",
  favoritesContinueSubTitle: "Spring terug in jou onlangse speletjies",
  homeFavoritesCarouselTitle: "{{alias}}, speel jou gunstelinge",
  homeFavoritesCarouselTitleGeneric: "SPEEL JOU GUNSTELINGE",
  homeFavoritesCarouselSubTitle: "Jou topspeletjies, altyd byderhand",
  lotteryGamesTitle: "LOTERYSPELETJIES",
  lotteryGamesSubTitle: "Probeer jou geluk met ons loteryspeletjies",
  animalitosExpressTitle: "VINNIGE KOOP ANIMALITOS",
  animalitosExpressSubTitle: "Kies, koop en wen onmiddellik",
  animalitosExpressBuy: "Koop",
  animalitosExpressAll: "Almal",
  qbErrorAmount: "Voer 'n geldige bedrag in",
  qbErrorMinBet: "Minimum {{min}} Bs",
  qbErrorMaxBet: "Maksimum {{max}} Bs",
  qbErrorBalance: "Onvoldoende saldo",
  qbErrorDrawClosed: "Trekking gesluit",
  qbSuccessTitle: "Aankoop suksesvol!",
  qbClose: "Sluit",
  qbAriaLabel: "Vinnige koop animalito",
  qbNextDraw: "Trekking",
  qbNoDraws: "Geen trekkings beskikbaar",
  qbDrawClosed: "Gesluit",
  qbAmountLabel: "Wedbedrag",
  qbConfirm: "Bevestig aankoop",
  providerBgamingTitle: "BGAMING SPELETJIES",
  providerBgamingSubtitle: "Die beste BGaming-speletjies",
  providerEvoplayTitle: "EVO PLAY SPELETJIES",
  providerEvoplaySubtitle: "Onbeperkte pret met Evo Play",
  providerPragmaticTitle: "PRAGMATIC SPELETJIES",
  providerPragmaticSubtitle: "Die beste van Pragmatic Play",
  allGamesTitle: "ALLE SPELETJIES",
  subcategoryAll: "Almal",
  subcategoryShowMore: "Wys meer",
  subcategoryShowLess: "Wys minder",
  subcategoryFilterLabel: "Filter volgens subkategorie",
  dontMiss: "MOENIE ENIGE TOERNOOI MIS NIE",
  dontMissTournaments: "Moenie enige van die Randrush-toernooie mis nie",
  tournamentRules: "Reëls",
  promoFeatured: "Uitgeligte byeenkoms",
  promoPrizePool: "Pryspoel",
  promoTimeLeft: "Tyd oor",
  promoTimeLeftDays: "d",
  promoTimeLeftHours: "u",
  promoTimeLeftMinutes: "m",
  promoPlayers: "Spelers",
  promoRecentPlayers: "Onlangse spelers",
  promoViewProfile: "Profiel",
  promoViewStories: "Stories",
  promoAddContact: "Voeg by",
  promoJoinNow: "Sluit aan",
  promoLearnMore: "Leer meer",
  promoViewGames: "Bekyk speletjies",
  promoLive: "LEWENDIG",
  promoCasinoLive: "BESTE VAN LEWENDIGE CASINO",
  promoContests: "LEWENDIGE KOMPETISIES",
  // Multi-Game-sweefknoppie-vertalings
  multiGameFloatingButton: "Vinnige speletjies",
  quickGamesTitle: "Vinnige speletjies",
  quickGamesDescription: "Hou aan speel terwyl jy vir jou hoofspeletjie wag!",
  hideQuickGames: "Versteek",
  minimizeQuickGames: "Minimeer",
  playNow: "Speel nou",
  noQuickGamesAvailable: "Geen speletjies op die oomblik beskikbaar nie",
  unknownGame: "Onbekende speletjie",
  unknownProvider: "Onbekend",
  loadingGames: "Laai speletjies...",
  gameLoading: "Laai speletjie",
  gameErrorTitle: "Kon nie die speletjie laai nie",
  gameErrorDescription:
    "Iets het verkeerd geloop terwyl die speletjie oopgemaak is. Kontroleer jou verbinding en probeer weer.",
  gameRetry: "Probeer weer",
  gameGoBack: "Gaan terug",
  miniJuegosHeroTitle: "Mini-speletjies",
  miniJuegosHeroAccent: "Vinnig",
  miniJuegosHeroSub: "Vinnige, intense, aksiebelaaide speletjies. Wen in sekondes.",
  miniJuegosStatGames: "Speletjies",
  miniJuegosStatCategories: "Kategorieë",
  miniJuegosCategories: "Mini-speletjie-kategorieë",
  miniJuegosLoading: "Laai mini-speletjies...",
  miniJuegosEmpty: "Geen mini-speletjies beskikbaar",
  miniJuegosCatAll: "Almal",
  miniJuegosCat_crash: "CRASH SPELETJIES",
  miniJuegosCatSub_crash: "Wed en trek uit voor die crash",
  miniJuegosCat_chicken: "HOENDER SPELETJIES",
  miniJuegosCatSub_chicken: "Hoenderavonture en pryse",
  miniJuegosCat_mines: "MYNVEER",
  miniJuegosCatSub_mines: "Vermy die myne en wen",
  miniJuegosCat_plinko: "PLINKO",
  miniJuegosCatSub_plinko: "Laat val en vermenigvuldig",
  miniJuegosCat_sports: "SPORT",
  miniJuegosCatSub_sports: "Ontspanne en sportspeletjies",
  miniJuegosCat_lottery: "LOTERY",
  miniJuegosCatSub_lottery: "Krap, spin en wen onmiddellik",

  // Hero-banierskuif 2-vertalings
  casinoSlide2Title: "Beleef die ",
  casinoSlide2Accent: "ervaring",
  casinoSlide2Sub: "Roulette, Blackjack, Baccarat en meer met professionele lewendige handelaars.",
  slotsSlide2Title: "Jou pret ",
  slotsSlide2Accent: "sonder perke",
  slotsSlide2Sub: "Duisende slots, tafelspeletjies en meer wag op jou.",
  miniJuegosSlide2Title: "Wen ",
  miniJuegosSlide2Accent: "onmiddellik",
  miniJuegosSlide2Sub: "Crash, Mines, Plinko en meer vinnige speletjies met onmiddellike pryse.",
  lotterySlide2Title: "Uitslae ",
  lotterySlide2Accent: "intyds",
  lotterySlide2Sub: "Volg jou gunstelingtrekkings en haal jou pryse onmiddellik af.",
  horsesSlide2Title: "Wed ",
  horsesSlide2Accent: "lewendig",
  horsesSlide2Sub: "Nasionale en internasionale wedrenne met lewendige stroom.",
  gameSearchPlaceholder: "Soek speletjies...",
  gameSearchAriaLabel: "Soek speletjies",
  gameSearchClear: "Maak soektog skoon",
  gameSearchFilters: "Filters",
  gameSearchRemoveFilter: "Verwyder filter",
  gameSearchClearFilters: "Maak filters skoon",
  gameSearchProviders: "Verskaffers",
  gameSearchCategories: "KATEGORIEË",
  gameSearchResults: "uitslae",
  categoryDice: "Dobbelstene",
  categoryFishing: "Visvang",
  categoryVirtualSports: "Virtuele sport",
  categoryTableGames: "Tafelspeletjies",
  categoryDomino: "Domino",
  categoryPoker: "Poker",
  casinoHeroTitle: "Lewendige casino",
  casinoHeroAccent: "Regte",
  casinoHeroSub: "Lewendige tafels met regte handelaars. Die casino-ervaring, uit jou stoel.",
  casinoGamesCount: "Speletjies",
  casinoProviders: "Verskaffers",
  casinoLiveLabel: "Lewendig",
  casinoTrending: "Neiging",
  casinoQuickPlay: "Vinnige speel",
  casinoSearchResults: "Uitslae",
  casinoAllGames: "Alle lewendige speletjies",
  casinoNoGames: "Geen speletjies gevind nie",
  casinoAll: "Almal",
  viewAll: "Sien alles",
  loadMore: "Laai meer",
  previous: "Vorige",
  next: "Volgende",
  casinoWinnersAria: "Jongste wenners",
  casinoBadgeHot: "Warm",
  casinoBadgeNew: "Nuut",
  casinoBadgePopular: "Gewild",
  casinoCatRoulette: "Roulette",
  casinoCatBlackJack: "Blackjack",
  casinoCatBaccarat: "Baccarat",
  casinoCatSicbo: "Sic Bo",
  casinoCatOneBJ: "Een Blackjack",
  casinoCatDragonTiger: "Draak Tier",
  casinoCatContest: "Kompetisies",
  casinoCatABH: "ABH",
  casinoCatFootball: "Sokker",
  casinoCatChroma: "Chroma",
};
